import React from 'react';
import { Box, Button } from '@mui/material';
import type { AuditDynamicFormActionsProps } from '../../types/auditFormTypes';

const AuditDynamicFormActions: React.FC<AuditDynamicFormActionsProps> = React.memo(({
  isSubmitting,
  savingAction,
  auditStatus,
  onReject,
  onRevertToReady,
  showRejectAction = true,
  showRevertAction = true,
  submitButtonLabel = 'Process',
}) => {
  const rejectLoading = savingAction === 'reject';
  const revertLoading = savingAction === 'revert';
  const saveLoading = savingAction === 'save';
  const normalizedStatus = String(auditStatus || '').toLowerCase();
  const processedStatuses = ['finalized', 'auto_finalized', 'auto_created', 'finalize', 'rejected'];
  const canReject = showRejectAction && !processedStatuses.includes(normalizedStatus);
  const canRevert = showRevertAction && normalizedStatus !== 'ready';
  const canProcess = ![...processedStatuses, 'failed'].includes(normalizedStatus);

  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
      {canReject && (
        <Button
          variant="contained"
          size="medium"
          disabled={isSubmitting}
          sx={{
            flex: 1,
            height: '44px',
            borderRadius: '8px',
            fontWeight: 600,
            fontSize: '15px',
            position: 'relative',
            backgroundColor: '#FF0000',
          }}
          onClick={onReject}
        >
          {rejectLoading ? 'Saving...' : 'Reject'}
        </Button>
      )}

      {canRevert && (
        <Button
          variant="contained"
          size="medium"
          disabled={isSubmitting}
          sx={{
            flex: '1.25',
            height: '44px',
            borderRadius: '8px',
            fontWeight: 600,
            fontSize: '15px',
            position: 'relative',
            backgroundColor: '#222B45',
          }}
          onClick={onRevertToReady}
        >
          {revertLoading ? 'Saving...' : 'Revert'}
        </Button>
      )}

      {canProcess && (
        <Button
          type="submit"
          variant="contained"
          size="medium"
          disabled={isSubmitting}
          sx={{
            flex: 1,
            height: '44px',
            borderRadius: '8px',
            fontWeight: 600,
            fontSize: '15px',
            position: 'relative',
            backgroundColor: '#2C6CA0',
          }}
        >
          {saveLoading ? 'Saving...' : (submitButtonLabel || 'Process')}
        </Button>
      )}
    </Box>
  );
});

AuditDynamicFormActions.displayName = 'AuditDynamicFormActions';

export default AuditDynamicFormActions;
